import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { openModal, setActiveProduct } from '../../../../Features/dropTrackProductsSlice';
import { getProductByID } from '../../../../lib/utils/apiCalls';
import { getCachedMediaUrl } from '../../../../lib/utils/utils';

function DropTrackListItem({ product }) {
    const {
        productId,
        stocks,
        currentPrice,
        dropWatcher
    } = product;

    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [dtProduct, setDTProduct] = useState({});

    const handleActionButton = (event) => {
        event.preventDefault();
        event.stopPropagation();
        dispatch(setActiveProduct(product));
        dispatch(openModal());
    };

    const handleViewClick = () => {
        navigate(`${location.pathname}/${productId}`);
    }

    useEffect(() => {
        const getProduct = async () => {
            const response = await getProductByID(productId);
            if(response?.status === 200) {
                setDTProduct({
                    ...response?.data?.product,
                    imageUrl: getCachedMediaUrl(response?.data?.product?.productImgUrls[0])
                });
            }
        }

        productId && getProduct()
    }, [productId]);

    return (
        <div className="flex items-center border-t border-[#EAEAEA] font-medium">
            <div className="w-[44%] max-[1280px]:w-[39.5%] px-[10px] py-[6px] flex gap-[11px] items-center">
                <div className="size-16 rounded-lg overflow-hidden select-none">
                    {
                        dtProduct?.imageUrl ? 
                        <img className='size-full object-cover bg-[#EAEAEA]' src={dtProduct.imageUrl} alt="" /> : 
                        <div className="size-16 bg-[#EAEAEA]"></div>
                    }
                </div>

                <div className="flex flex-col gap-1 w-[calc(100%-64px-11px)]">
                    {
                        dtProduct?.productName ? 
                        <h2 className="font-semibold text-[14px] leading-6 text-[#121212] whitespace-nowrap overflow-hidden text-ellipsis select-none">{dtProduct.productName}</h2> : 
                        <div className="h-6 w-full bg-[linear-gradient(90deg,_rgba(235,235,235,1)_0%,_rgba(255,255,255,1)_100%)]"></div>
                    }
                </div>
            </div>

            <h2 className="w-[14%] max-[1280px]:w-[16%] max-[1152px]:w-[15%] max-[1080px]:w-[13%] px-[10px] py-[26px] text-[14px] leading-6 text-[#121212] select-none">{dropWatcher}</h2>

            <h2 className="w-[13%] max-[1280px]:w-[13%] px-[10px] py-[26px] text-[14px] leading-6 text-[#121212] select-none">₹{currentPrice}</h2>

            <h2 className="w-[13%] max-[1280px]:w-[13%] max-[1152px]:w-[12%] px-[10px] py-[26px] text-[14px] leading-6 text-[#121212] select-none">{stocks ? stocks : '0'}</h2>

            <div className="w-[16%] max-[1280px]:w-[18.5%] max-[1152px]:w-[20.5%] max-[1080px]:w-[22.5%] flex gap-2 items-center px-[10px] py-5">
                <button onClick={handleViewClick} className='font-semibold outline-none select-none text-[12px] leading-6 text-[#121212] w-fit px-3 py-[6px] border border-[#757575] bg-[#F0F0F0] rounded'>
                    View
                </button>

                <button onClick={handleActionButton} className='font-semibold outline-none select-none text-[12px] leading-6 text-[#121212] w-fit px-3 py-[6px] border border-[#757575] bg-[#F0F0F0] rounded'>
                    Take Action
                </button>
            </div>
        </div>
    );
}

export default DropTrackListItem;
